import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Outlet, useNavigate } from "react-router-dom";
import { RootState } from "../store/store";
import Loading from "./Loading";

const PrivateOutlet: React.FC = () => {
  const navigate = useNavigate();
  const { user, loading } = useSelector((state: RootState) => state.auth);

  useEffect(() => {
    if (!loading && !user) {
      console.log(
        "User not authenticated, redirecting to login",
        loading,
        user
      );
      navigate("/login");
    }
  }, [user, loading, navigate]);

  if (loading) {
    return <Loading />;
  }

  return <Outlet />;
};

export default PrivateOutlet;
